import React, { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import AOS from "aos";
import "aos/dist/aos.css";

// --- Placeholder Images ---
// **REPLACE THESE WITH YOUR ACTUAL IMAGE IMPORTS/URLS!**
import img1 from "../../assets/marquee/2.jpg";
import img2 from "../../assets/marquee/1.jpg";
import img3 from "../../assets/marquee/3.jpg";
import img4 from "../../assets/marquee/4.jpg";
import img5 from "../../assets/marquee/5.jpg";

const MarqueeProjects = () => {
  const marqueeRef = useRef(null);
  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  // Sample project data - ADDED an 'image' property
  const projects = [
    {
      id: 1,
      title: "Quantolio Insights",
      description: "Supercharge your operations",
      category: "UI/UX Design",
      image: img1,
    },
    {
      id: 2,
      title: "AI Craft Magic",
      description: "Next-gen AI solutions",
      category: "Digital Solution",
      image: img2,
    },
    {
      id: 3,
      title: "Love Beauty & Planet",
      description: "E-commerce experience",
      category: "Branding & Web",
      image: img3,
    },
    {
      id: 4,
      title: "FinTech Dashboard",
      description: "Data visualization platform",
      category: "UI/UX Design",
      image: img4,
    },
    {
      id: 5,
      title: "EcoMarket",
      description: "Sustainable shopping app",
      category: "Mobile App",
      image: img5,
    },
  ];

  // Duplicate the projects for seamless looping
  const duplicatedProjects = [...projects, ...projects];

  // --- Dark Theme Color Variables for a sleek look ---
  const darkBg = "#080B13";
  const headingColor = "#c5c6c7";
  const primaryColor = "#66fcf1"; // A neon/cyan color for contrast

  return (
    <section
      ref={ref}
      className="marquee-projects-section"
      style={{
        padding: "3rem 0",
        overflow: "hidden",
        width: "200vw", // Full width for the section
      }}
    >
      <div
        // Removed width and margin: "0 auto" for full-page effect
        style={{ padding: "0 0" }}
      >
        <div
          className="marquee-container"
          style={{
            position: "relative",
            width: "100%",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >

          <div
            ref={marqueeRef}
            className="marquee-track"
            style={{
              display: "flex",
              width: "max-content",
              // Increased duration for a slower, more deliberate scroll
              animation: inView
                ? "marqueeAnimation 100s linear infinite"
                : "none",
            }}
          >
            {duplicatedProjects.map((project, index) => (
              <div
                key={`${project.id}-${index}`}
                className="project-card"
                style={{
                  flex: "0 0 auto",
                  width: "700px", // **INCREASED WIDTH**
                  height: "450px", // **INCREASED HEIGHT**
                  margin: "0 2rem", // Increased margin for spacing
                  borderRadius: "8px",
                  overflow: "hidden",
                  position: "relative",
                  cursor: "default", // Changed to default since hover is remove
                }}
                data-aos="fade-up" // Changed from zoom-in for better look
                data-aos-delay={(index % 6) * 100}
              >
                {/* --- Project Image Container --- */}
                <img
                  src={project.image}
                  alt={project.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    // No transform transition as hover is removed
                  }}
                  className="project-image"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>
        {`
          /* Keyframes remain the same */
          @keyframes marqueeAnimation {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          
          /* **NEW CSS FOR BOTTOM FADE EFFECT** */
          .project-card {
            position: relative; /* Essential for absolute pseudo-element */
          }

          .project-fade-overlay {
            bottom: 0;
            left: 0;
            right: 0;
            height: 50%; /* Start the fade from half-way up the image */
            pointer-events: none;
            z-index: 2; /* Ensure it's above the image but below the text overlay */
          }

          .project-card:hover .project-overlay {
            transform: none !important;
          }
          
          .project-card:hover .project-image {
            transform: none !important;
          }

          /* Media queries for responsiveness */
          @media (max-width: 1200px) {
            .project-card {
              width: 550px !important;
              height: 380px !important;
            }
            .project-title {
              font-size: 2rem !important;
            }

            
          }
          
          @media (max-width: 768px) {
            .marquee-track {
              animation-duration: 55s !important;
            }
            
            .project-card {
              width: 85vw !important; /* Take up most of the screen width */
              height: 250px !important;
              margin: 0 1rem !important;
            }

            .project-title {
              font-size: 1.5rem !important;
            }
            
            .project-overlay {
                padding: 1.2rem !important;
            }

            .project-category {
                font-size: 0.8rem !important;
            }

            /* Reduce fade overlay width for mobile */
            .fade-overlay {
              width: 100px !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default MarqueeProjects;
